let cached: boolean | null = null;

/** True only when the URL contains ?debug=1. */
export function isDebug(): boolean {
  if (cached !== null) return cached;
  try {
    cached = new URLSearchParams(window.location.search).get("debug") === "1";
  } catch {
    cached = false;
  }
  return cached;
}

export function debugLog(...args: unknown[]): void {
  if (isDebug()) console.info(...args);
}
